export const getCheckboxOptions = (affirmativeText?: string, negativeText?: string) => [
  { value: true, text: affirmativeText ?? 'Yes' },
  { value: false, text: negativeText ?? 'No' },
];
